import React from 'react'

import './styles.css'

const ChangeIncrement = ({ id, icon = 'plus', color = '#333', width = '50px', updateQuantity, disabled }) => {
  color = disabled ? '#666' : color
  return (
    <button className="ct-increment-button" disabled={disabled} style={disabled ? {pointerEvents: 'none', opacity: .5} : {}} onClick={() => {
      const value = icon === 'plus' ? 1 : -1
      updateQuantity(id, value, true)
    }}>
      {icon === 'plus' ? (
        <svg style={{ width: width }} aria-hidden="true" focusable="false" data-prefix="fal" data-icon="plus-circle" className="svg-inline--fa fa-plus-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill={color} d="M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"></path></svg>
      ) : (
        <svg style={{ width: width }} aria-hidden="true" focusable="false" data-prefix="fal" data-icon="minus-circle" className="svg-inline--fa fa-minus-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill={color} d="M140 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H140zm364-18c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"></path></svg>
      )}
    </button>
  )
}

export default ChangeIncrement
